export const MOVE_CYCLE_BANNER_TEXT =
  'The proposal round has ended and new proposals can no longer be submitted for the current cycle. Please click the Move to Next Round button above or wait until another user does so and the new proposal round starts.'
